import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CsvUploadService {
    private _url = `https://${window.location.host}/api/v0.5/csvupload/`;

    constructor(private http: HttpClient) {}

    uploadCsv(uploadType: UploadType, formData: FormData): Observable<IDataValidationResult> {
        let params = new HttpParams().set('uploadType', uploadType.toString());
        return this.http.post<IDataValidationResult>(this._url + 'UploadCsv', formData, {
            params: params,
            reportProgress: true,
        });
    }

    uploadFile(file: any, uploadPath: string) {
        let form = new FormData();
        form.append('file', file);

        return this.http.post(`${this._url}${uploadPath}`, form);
    }

    getCurrentUploadedDataAsCsv(
        uploadType: UploadType,
        fileName: string,
        returnData: boolean
    ): Observable<Blob> {
        const params = new HttpParams()
            .set('uploadType', uploadType.toString())
            .set('fileName', fileName)
            .set('returnData', returnData);
        return this.http.get<Blob>(this._url + 'GetCurrentUploadedDataAsCsv', {
            params: params,
            responseType: 'blob' as 'json',
        });
    }

    getFileUploadStatus(uploadType: UploadType): Observable<ISavedCsvUploadStatus[]> {
        let params = new HttpParams().set('uploadType', uploadType.toString());
        return this.http.get<ISavedCsvUploadStatus[]>(this._url + 'GetFileUploadStatus', {
            params: params,
        });
    }

    downloadCsvFile(type: string, returnData: boolean): Observable<Blob> {
        const params = new HttpParams().set('type', type).set('returnData', returnData);
        return this.http.get<Blob>(`${this._url}data`, {
            params: params,
            responseType: 'blob' as 'json',
        });
    }
}

export type UploadType = 'ProductMapping' | 'GeneralLedger' | 'Hierarchy' | 'Employees';

export interface IDataValidationResult {
    isHeaderValid: boolean;
    headerMessage: string;
    dataMessage: string;
}

export interface ISavedCsvUploadStatus {
    uploadStatus: string;
    reason: string;
    initialCheckStatus: string;
    uploadData: string;
    insertTime: Date;
    fileName: string;
    rowNumber: string;
}

export interface IUploadTypeInfo {
    index: number;
    title: string;
    uploadType: UploadType;
    isUploaded: boolean;
}

export interface IFileUploadItemInfo {
    title: string;
    uploadType: UploadType;
    id: string;
    showSpinner: boolean;
    maxFileSize: string;
    downloadMessage: string;
}
